import { SET_BUSINESS_CURRENCIES, SET_CURRENCIES, SET_CURRENCY } from "../../constants/currencyConstants";

export const setCurrency = (currency) => {
  return {
    type: SET_CURRENCY,
    currency,
  };
};

export const setCurrencies = (currencies, filtered = false) => {
  return {
    type: SET_CURRENCIES,
    currencies,
    filtered,
  };
};

export const setBusinessCurrencies = (businessCurrencies, lastUpdatedDate) => {
  return {
    type: SET_BUSINESS_CURRENCIES,
    businessCurrencies,
    lastUpdatedDate,
  };
};
